<template>
  <div>
    <b-card bg-variant="light">
    <Transition>
      <b-img v-if="!id" fluid src="https://unicorn-farm-image-asset.s3.us-east-2.amazonaws.com/unicorn-gray-card.png"></b-img>
    </Transition>
      <b-row aria-controls="table-transition-example">
        <b-col md="7" key="c1">
        <TransitionGroup name="list" tag="ul">
            <collection-images-summary v-if="id" :id="id" key="t1"></collection-images-summary>

            <collection-image-create v-if="ams_image_template.description" key="t2"
              :filtering="filtering"
              :ams_template="ams_image_template"
            >
            </collection-image-create>

        </TransitionGroup>
        </b-col>
        <b-col md="5" key="c2">
        <TransitionGroup name="list" tag="ul">
          <collection-show :id="id" @gotAttrs="assignAttrs" v-if="id" key="t3"></collection-show>
          <b-button block variant="primary" @click="addAsset" v-if="id" key="t4">Add Asset to Collection</b-button>
        </TransitionGroup>
        </b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
import CollectionImageCreate from './CollectionImageCreate.vue'
import CollectionImagesSummary from './CollectionImagesSummary.vue'
import CollectionShow from './CollectionShow.vue'
import {http_v1} from '@/axios'
import {ADMIN_PATH, COLLECTIONS, amsApiResourcePath} from '@/ams_route.js'

export default {
  components: {
    CollectionImageCreate,
    CollectionImagesSummary,
    CollectionShow
  },
  data () {
    return {
      included: [],
      items: [],
      filtering: {
        collection_ids: undefined
      },
      id: undefined,
      attrs: {},
      // description: '',
      ams_image_template: {
        type: 'collection-images',
        description: undefined,
        attributes: {
          'collection-id': this.id,
        }
      },
      ams_item_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': undefined,
          'storage-space-id': this.id,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
    }
  },
  methods: {
    apiResourcePath() {
      return 
    },
    callApi () {
      let sorting = "-updated_at"
      http_v1.get (
        amsApiResourcePath(ADMIN_PATH, COLLECTIONS), {
          params: {
            sort: sorting
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.items = response.data.data
          this.included = response.data.included
          this.items.forEach(el => {if(el.attributes) {Object.assign(el, el.attributes)}})
          this.id = this.items[0].id
          this.ams_image_template.attributes['collection-id'] = this.id
          this.ams_item_template.attributes['storage-space-id'] = this.id
          this.filtering.collection_ids = this.id
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_image_template.description = this.attrs['name'] + ' ' + description
      this.ams_item_template.description = description + ' ' + this.attrs['name']
    },
    addAsset() {
        this.$router.push( {
          name: 'ProductItemCreateScreen',
          params: {
            ams_template: this.ams_item_template
          }
        })
    }
  },
  mounted() {
    this.callApi()
  }
}
</script>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 2.0s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 1.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}

table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
